// Timestamp formatting for the UI.
//
// The fleet is operated from the +8 region (Taiwan / Asia), so every timestamp
// is rendered in Asia/Taipei (UTC+8, no DST) rather than the viewer's local
// zone or raw UTC. Backend timestamps are tz-aware UTC ISO strings; a naive
// string (no zone) is assumed UTC so it is never misread as browser-local.
const TZ = "Asia/Taipei";

function toDate(input) {
  if (input == null || input === "") return null;
  if (input instanceof Date) return input;
  let s = String(input);
  // ISO datetime without a zone designator -> treat as UTC
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s) && !/([Zz]|[+-]\d{2}:?\d{2})$/.test(s)) s += "Z";
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

// Short form: "21 Aug, 14:32" in +8.
export function fmtTime(input, opts = {}) {
  const d = toDate(input);
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false, ...opts,
  }).format(d);
}

// Full form with year: "21 Aug 2026, 14:32" in +8.
export function fmtDateTime(input) {
  return fmtTime(input, { year: "numeric" });
}

// Date only: "21 Aug 2026" in +8.
export function fmtDate(input) {
  const d = toDate(input);
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-GB", { timeZone: TZ, day: "2-digit", month: "short", year: "numeric" }).format(d);
}
